module.exports = __webpack_public_path__ + "static/img/no-image.a5acc5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/items/no-image.png
// module id = L1dy
// module chunks = 1